import { Skeleton } from '@/components/ui/skeleton';

export default function ProductLoadingSkeleton() {
  return (
    <main className="mx-auto max-w-7xl space-y-10">
      <div className="flex flex-col gap-4 md:flex-row">
        <div className="basis-3/5">
          <Skeleton className="aspect-square w-full" />
        </div>
        <div className="basis-3/5 space-y-4">
          <Skeleton className="h-28 w-full" />
          <Skeleton className="h-6 w-56" />
          <Skeleton className="h-14 w-full" />
          <Skeleton className="h-10 w-44" />
          <div className="flex flex-row gap-4">
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-20 w-full" />
            <Skeleton className="h-20 w-full" />
          </div>
          <Skeleton className="h-16 sm:w-44 w-full rounded-full" />
        </div>
      </div>
    </main>
  );
}
